import { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import fr from './translations/fr';
import en from './translations/en';

const translations = { fr, en };

const useTranslation = () => {
  const context = useContext(LanguageContext);
  const language = context?.language || 'fr';
  const t = translations[language] || translations.fr;
  return { t, language };
};

export { useTranslation };
export default useTranslation;
